import { useState, useEffect } from "react";
import Loader from "../../../../../../Component/DigitalMarketing/Loader";
import { formatDate, formatWord } from "../../../../Utils/utils";
import OptionsDropdown from "../../../../../../Component/DigitalMarketing/Forms/OptionsDropdown";
import { useLocation } from "react-router-dom";

const PrescriptionsList = (props: any) => {
  const options = ["Edit"];
  const {
    data,
    setShowAddPrescription,
    setEditMode,
    setViewPrescription,
    setView,
    isPending,
    initialState,
  } = props;

  const [selectedPrescriptionIndex, setSelectedPrescriptionIndex] = useState<
    number | null
  >(null);

  const location = useLocation();

  const { consultantId } = location.state || {};

  useEffect(() => {
    if (data?.data?.length > 0) {
      setSelectedPrescriptionIndex(0);
      setView(true);
      setViewPrescription(data?.data[0]);
    }
  }, [data]);

  const handlePrescriptionClick = (index: number, p: any) => {
    setView(true);
    setShowAddPrescription(false);
    setEditMode(false);
    setSelectedPrescriptionIndex(index);
    setViewPrescription(p);
  };

  const handleEdit = (p: any) => {
    setEditMode(true);
    setShowAddPrescription(true);
    setView(false);
    setViewPrescription(p);
  };

  const handleAdd = () => {
    setViewPrescription(initialState);
    setShowAddPrescription(true);
    setEditMode(false);
    setView(false);
  };

  if (isPending) {
    return <Loader loading={true} />;
  }

  return (
    <div style={{ maxHeight: "80vh", overflowY: "auto" }}>
      {consultantId && (
        <div className="d-flex justify-content-between mt-2">
          <span className="f-16 fw-500 fw-bold">Prescription log</span>
          <span
            className="material-symbols-outlined rounded cursor-pointer"
            style={{
              color: "white",
              width: "25px",
              height: "25px",
              backgroundColor: "#6842D9",
            }}
            onClick={() => handleAdd()}
          >
            add
          </span>
        </div>
      )}
      {data?.data?.length > 0 ? (
        data?.data?.map((p: any, i: number) => (
          <div className="mt-3" key={p.id || i}>
            <div
              className="card p-2 cursor-pointer"
              style={{
                backgroundColor:
                  selectedPrescriptionIndex === i ? "#F3F5FB" : "transparent",
              }}
              onClick={() => handlePrescriptionClick(i, p)}
            >
              <div>
                <span>{formatDate(p?.createdAt)}</span>
              </div>
              <div>
                <span className="f-18 fw-400">
                  {formatWord(p.prescriptionTitle)}
                </span>
              </div>
              <div className="d-flex justify-content-between">
                <span className="f-18 fw-400">
                  by <span style={{ color: "#007AFF" }}>you</span>
                </span>
                <div
                  style={{ zIndex: 100000 }}
                  onClick={(e) => e.stopPropagation()}
                >
                  <OptionsDropdown
                    options={options}
                    onOptionClick={(option: any) => {
                      if (option === "Edit") {
                        handleEdit(p);
                      }
                    }}
                  />
                </div>
              </div>
            </div>
          </div>
        ))
      ) : (
        <div
          className=" d-flex justify-content-center align-items-center"
          style={{ height: "80vh" }}
        >
          <span className="fw-bold">No Prescriptions !</span>
        </div>
      )}
    </div>
  );
};

export default PrescriptionsList;
